export const financialConstants = {
	MERCHANT_FINANCIALS_ADD_LOCAL_BANK_BALANCE:
		"MERCHANT_FINANCIALS_ADD_LOCAL_BANK_BALANCE",
	MERCHANT_FINANCIALS_EDIT_LOCAL_BANK_BALANCE:
		"MERCHANT_FINANCIALS_EDIT_LOCAL_BANK_BALANCE",
	MERCHANT_FINANCIALS_DELETE_LOCAL_BANK_BALANCE:
		"MERCHANT_FINANCIALS_DELETE_LOCAL_BANK_BALANCE",

	MERCHANT_FINANCIALS_ADD_LOCAL_FINANCIAL:
		"MERCHANT_FINANCIALS_ADD_LOCAL_FINANCIAL",
	MERCHANT_FINANCIALS_EDIT_LOCAL_FINANCIAL:
		"MERCHANT_FINANCIALS_EDIT_LOCAL_FINANCIAL",
	MERCHANT_FINANCIALS_DELETE_LOCAL_FINANCIAL:
		"MERCHANT_FINANCIALS_DELETE_LOCAL_FINANCIAL",

	MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_REQUEST:
		"MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_REQUEST",
	MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_SUCCESS:
		"MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_SUCCESS",
	MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_ERROR:
		"MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_ERROR",

	MERCHANT_FINANCIALS_SAVE_FINANCIALS_REQUEST:
		"MERCHANT_FINANCIALS_SAVE_FINANCIALS_REQUEST",
	MERCHANT_FINANCIALS_SAVE_FINANCIALS_SUCCESS:
		"MERCHANT_FINANCIALS_SAVE_FINANCIALS_SUCCESS",
	MERCHANT_FINANCIALS_SAVE_FINANCIALS_ERROR:
		"MERCHANT_FINANCIALS_SAVE_FINANCIALS_ERROR",
};
